import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import nl from 'vuetify/src/locale/nl';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#15b3f9'
      }
    }
  },
  icons: {
    iconfont: 'mdi'
  },
  lang: {
    locales: { nl },
    current: 'nl'
  }
});
